import { TabbedContent } from 'src/design-system'
import * as React from 'react'
import * as SecondaryNav from 'components/secondary-nav'
import { useStore } from 'store/context'
import { WorkFeedLayout } from 'components/home-page/work-feed/wrapper'
import { observer } from 'mobx-react-lite'
import { LayoutButton } from 'components/home-page/work-feed/work-feed-nav/layout-button'
import { WinsPageTab } from './wins-page-tab'
import { convertValueToUserIds } from 'components/manager-user-select/utils'
import { ManagerUserSelect } from 'components/manager-user-select'

export type tabIdType = 'received' | 'given' | 'org' | 'team'

export const WinsPage = observer(() => {
  const { nonNullCurrentUser, userSkills } = useStore()

  const [layout, setLayout] = React.useState<WorkFeedLayout>('list')

  const [managerSelectValue, setManagerSelectValue] = React.useState(
    nonNullCurrentUser.id
  )

  const [tabId, setTabId] = React.useState('received' as tabIdType)

  const userId = convertValueToUserIds(nonNullCurrentUser, managerSelectValue)

  const focusSkillIds = userSkills.focusedSkillIdsForUser(nonNullCurrentUser.id)
  const teamUserIds = nonNullCurrentUser.team?.users.map((u) => u.id) || []

  const displayManagerUseSelect =
    nonNullCurrentUser.isManager && (tabId == 'given' || tabId == 'received')

  return (
    <TabbedContent.Root
      initialTabId={tabId}
      id="wins-page"
      data-testid="wins-page"
      className="flex-1 max-w-full"
    >
      <SecondaryNav.Root>
        <SecondaryNav.Header className="flex flex-row items-center justify-between w-full">
          <div className="flex flex-row items-center gap-4">
            Wins
            <TabbedContent.Tabs
              variant="pill"
              className="gap-1 overflow-y-auto"
              data-element-id="create-form-tabs"
            >
              <TabbedContent.Tab
                id="org"
                key="org"
                onClick={() => setTabId('org')}
              >
                Org
              </TabbedContent.Tab>
              {nonNullCurrentUser.team && (
                <TabbedContent.Tab
                  id="team"
                  key="team"
                  onClick={() => setTabId('team')}
                >
                  Team
                </TabbedContent.Tab>
              )}
              <TabbedContent.Tab
                id="received"
                key="received"
                onClick={() => setTabId('received')}
              >
                Received
              </TabbedContent.Tab>
              <TabbedContent.Tab
                id="given"
                key="given"
                onClick={() => setTabId('given')}
              >
                Given
              </TabbedContent.Tab>
              {displayManagerUseSelect && (
                <ManagerUserSelect
                  defaultValue={nonNullCurrentUser.id}
                  onChange={(value) =>
                    setManagerSelectValue(value ? value : nonNullCurrentUser.id)
                  }
                  user={nonNullCurrentUser}
                />
              )}
            </TabbedContent.Tabs>
          </div>
          <SecondaryNav.Actions>
            <LayoutButton layout={layout} onLayoutChange={setLayout} />
          </SecondaryNav.Actions>
        </SecondaryNav.Header>
      </SecondaryNav.Root>
      <TabbedContent.Content tabId="received" key="received">
        <WinsPageTab
          focusSkillIds={focusSkillIds}
          layout={layout}
          tabId={tabId}
          userId={userId}
        />
      </TabbedContent.Content>
      <TabbedContent.Content tabId="given" key="given">
        <WinsPageTab
          focusSkillIds={focusSkillIds}
          layout={layout}
          tabId={tabId}
          userId={userId}
        />
      </TabbedContent.Content>
      <TabbedContent.Content tabId="org" key="org">
        <WinsPageTab
          focusSkillIds={focusSkillIds}
          layout={layout}
          tabId={tabId}
          userId={userId}
        />
      </TabbedContent.Content>
      {nonNullCurrentUser.team && (
        <TabbedContent.Content tabId="team" key="team">
          <WinsPageTab
            focusSkillIds={focusSkillIds}
            layout={layout}
            tabId={tabId}
            userId={userId}
            teamUserIds={teamUserIds}
          />
        </TabbedContent.Content>
      )}
    </TabbedContent.Root>
  )
})
